import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/admin/login',
    name: 'login',
    meta: {
      title: '登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login')
  },
  {
    path: '/admin',
    name: '_home',
    redirect: {
      name: 'login'
    },
    component: Main,
    // meta: { hideInMenu: true, notCache: true },
    meta: {
      title: '首页',
      icon: 'md-home'
    },
    children: [
      {
        path: '/admin/home',
        name: 'home',
        meta: {
          title: '数据看板',
          notCache: true,
          access: ['home-statis'],
        },
        component: () => import('@/view/home/index')
      },
      {
        path: '/admin/user/info',
        name: 'userInfo',
        meta: {
          title: '个人设置'
        },
        component: () => import('@/view/admin/userInfo')
      }
    ]
  },

  {
    path: '/admin/article',
    name: 'article',
    meta: {
      title: '文章管理',
      icon: 'ios-paper',
      // access: ['article']
    },
    component: Main,
    children: [
      {
        path: '/admin/article/list',
        name: 'articlelist',
        meta: {
          title: '系统调用',
          // access: ['article-articlelist']
        },
        component: () => import('@/view/article/list')
      },
      {
        path: '/admin/article/form/:id?',
        name: `articlelist_form`,
        meta: {
          title: '文章编辑',
          hideInMenu: true,
          // access: ['articlelist_form']
        },
        component: () => import('@/view/article/components/listEdit.vue')
      },
      {
        path: '/admin/article2/list',
        name: 'article2list',
        meta: {
          title: '资讯管理',
          // access: ['article2-articlelist']
        },
        component: () => import('@/view/article/list2')
      },
      {
        path: '/admin/article2/form/:id?/:sort?',
        name: `article2list_form`,
        meta: {
          title: '资讯编辑',
          hideInMenu: true,
          // access: ['articlelist2_form']
        },
        component: () => import('@/view/article/components/list2Edit.vue')
      },
      {
        path: '/admin/newscate/list',
        name: 'newsCatelist',
        meta: {
          title: '学习分类',
          // access: ['article2-articlelist']
        },
        component: () => import('@/view/news/list')
      },
      {

        path: '/admin/newscate/edit/:id?/:sort?',
        name: 'newsCatelistedit',
        meta: {
          title: '分类编辑',
          hideInMenu: true,
          // access: ['article2-articlelist']
        },
        component: () => import('@/view/news/components/listEdit.vue')
      },
      {
        path: '/admin/news/list',
        name: 'newslist',
        meta: {
          title: '学习管理',
          // access: ['article2-articlelist']
        },
        component: () => import('@/view/news/list2')
      },
      {

        path: '/admin/news/edit/:id?/:sort?',
        name: 'newsListEdit',
        meta: {
          title: '文章编辑',
          hideInMenu: true,
          // access: ['article2-articlelist']
        },
        component: () => import('@/view/news/components/list2Edit.vue')
      },
      {
        path: '/admin/article3/list',
        name: 'article3list',
        meta: {
          title: '轮播文章',
          // access: ['article2-articlelist']
        },
        component: () => import('@/view/article/list3')
      },
      {
        path: '/admin/article3/form/:id?',
        name: `article2list_form`,
        meta: {
          title: '文章编辑',
          hideInMenu: true,
          // access: ['articlelist2_form']
        },
        component: () => import('@/view/article/components/list3Edit.vue')
      },
      {
        path: '/admin/wechatArt/list',
        name: 'wechatArt',
        meta: {
          title: '公众号文章',
          // access: ['article2-articlelist']
        },
        component: () => import('@/view/news/wechatArt/list')
      },
      {

        path: '/admin/wechatArt/edit/:id?',
        name: 'wechatArtEdit',
        meta: {
          title: '文章编辑',
          hideInMenu: true,
          // access: ['article2-articlelist']
        },
        component: () => import('@/view/news/wechatArt/edit.vue')
      },
    ]
  },
  {
    path: '/admin/advert',
    name: 'advert',
    meta: {
      title: '广告管理',
      icon: 'ios-images',
      // access: ['advert']
    },
    component: Main,
    children: [
      {
        path: '/admin/advertPic/group',
        name: 'advertGroup',
        meta: {
          title: '幻灯管理',
          // access: ['advertGroup']
        },
        component: () => import('@/view/advertPic/groupList.vue')
      },
      {
        path: '/admin/advertPic/lb/:id?',
        name: 'advertLb',
        meta: {
          hideInMenu: true,
          notCache: true,
          title: '轮播图列表',
          // access: ['advertLb']
        },
        component: () => import('@/view/advertPic/list2.vue')
      },
      {
        path: '/admin/advert/list',
        name: 'advertList',
        meta: {
          title: '广告列表',
          // access: ['advert-advertList']
        },
        component: () => import('@/view/advertPic/singlePic')
      },
    ]
  },
  {
    path: '/admin/school',
    name: 'school',
    meta: {
      title: '幼儿园管理',
      icon: 'ios-images',
      // access: ['advert']
    },
    component: Main,
    children: [
      {
        path: '/admin/school/group',
        name: 'schoolList',
        meta: {
          title: '幼儿园列表',
          // access: ['advertGroup']
        },
        component: () => import('@/view/school/schoolList.vue')
      },
      {
        path: '/admin/school/lb/:id?',
        name: 'class',
        meta: {
          hideInMenu: true,
          notCache: true,
          title: '班级列表',
          // access: ['advertLb']
        },
        component: () => import('@/view/school/list.vue')
      },
      {
        path: '/admin/school/user/:id?',
        name: 'classuser',
        meta: {
          hideInMenu: true,
          notCache: true,
          title: '学员列表',
          // access: ['advertLb']
        },
        component: () => import('@/view/school/userlist.vue')
      },
      {
        path: '/admin/vip/list',
        name: '套餐',
        meta: {
          title: '套餐列表',
          // access: ['advert-advertList']
        },
        component: () => import('@/view/vip/index')
      },
      // {
      //   path: '/admin/user/orderlist',
      //   name: 'userOrder',
      //   meta: {
      //     title: '订单列表',
      //     // access: ['userOrder']
      //   },
      //   component: () => import('@/view/school/order/index')
      // },
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404')
  },
  {
    path: '/admin/user',
    name: 'user',
    meta: {
      title: '用户管理',
      icon: 'ios-person',
      // access: ['user']
    },
    component: Main,
    children: [
      {
        path: '/admin/user/userlist',
        name: 'userlist',
        meta: {
          title: '用户列表',
          // access: ['user-userlist']
        },
        component: () => import('@/view/user/userlist')
      },
      {
        path: '/admin/user/comments',
        name: 'commentslist',
        meta: {
          title: '心得列表',
          // access: ['user-userlist']
        },
        component: () => import('@/view/comments/index')
      },
      {
        path: '/admin/user/comments/:id?',
        name: `commentsInfo`,
        meta: {
          title: '心得详情',
          hideInMenu: true,
          // access: ['commentsInfo']
        },
        component: () => import('@/view/comments/edit')
      },
      {
        path: '/admin/withdraw',
        name: 'withdrawList',
        meta: {
          title: '提现申请',
          // access: ['withdrawList']
        },
        component: () => import('@/view/user/withdrawList')
      },

      // {
      //   path: '/admin/user/add/:id?',
      //   name: 'addUser',
      //   meta: {
      //     hideInMenu: true,
      //     notCache: true,
      //     title: '注册用户',
      //     access: ['user-addUser']
      //   },
      //   component: () => import('@/view/user/userAdd')
      // },
      // {
      //   path: '/user/userLevel',
      //   name: 'userLevel',
      //   meta: {
      //     title: '会员等级',
      //     access: ['user-userLevel']
      //   },
      //   component: () => import('@/view/user/userLevellist')
      // },
      // {
      //   path: '/admin/user/preArrive',
      //   name: 'preArrive',
      //   meta: {
      //     title: '预到账记录',
      //     access: ['user-preArrive']
      //   },
      //   component: () => import('@/view/user/preArriveList')
      // },
      // {
      //   path: '/admin/user/balance',
      //   name: 'balanceList',
      //   meta: {
      //     title: '余额变动记录',
      //     access: ['user-balance']
      //   },
      //   component: () => import('@/view/user/balanceList')
      // },
      // {
      //   path: '/admin/user/points',
      //   name: 'pointsList',
      //   meta: {
      //     title: '积分日志记录',
      //     access: ['pointsLogList']
      //   },
      //   component: () => import('@/view/user/pointsList')
      // },
      // {
      //   path: '/admin/vipCard',
      //   name: 'vipCard',
      //   meta: {
      //     title: '会员卡管理',
      //     access: ['vipCard']
      //   },
      //   component: parentView,
      //   children: [
      //     {
      //       path: '/admin/vipCard/list',
      //       name: 'vipCardList',
      //       meta: {
      //         title: '会员卡列表',
      //         access: ['vipCard-list']
      //       },
      //       component: () => import('@/view/vipCard/list')
      //     },
      //     {
      //       path: '/admin/vipCard/add/:id?',
      //       name: 'addCard',
      //       meta: {
      //         title: '添加会员卡',
      //         hideInMenu: true,
      //         notCache: true,
      //         access: ['add-card']
      //       },
      //       component: () => import('@/view/vipCard/cardEdit')
      //     },
      //     {
      //       path: '/admin/vipCard/setting',
      //       name: 'vipCardSetting',
      //       meta: {
      //         title: '会员卡类型',
      //         access: ['vipType-list']
      //       },
      //       component: () => import('@/view/vipCard/setting')
      //     },
      //     {
      //       path: '/admin/vipCard/setting/add/:id?',
      //       name: 'addCardSetting',
      //       meta: {
      //         title: '添加会员卡类型',
      //         hideInMenu: true,
      //         notCache: true,
      //         access: ['add-card-type']
      //       },
      //       component: () => import('@/view/vipCard/settingEdit')
      //     },
      //     {
      //       path: '/admin/vipCard/userList',
      //       name: 'card_userList',
      //       meta: {
      //         title: '会员卡订单',
      //         access: ['card-orderList']
      //       },
      //       component: () => import('@/view/vipCard/cardUserList')
      //     },
          // {
          //   path: '/admin/vipCard/refund',
          //   name: 'card_refundList',
          //   meta: {
          //     title: '退卡列表',
          //     access: ['card_refundList']
          //   },
          //   component: () => import('@/view/vipCard/refund/index')
          // }
        // ]
      // }
    ]
  },
  {
    path: '/admin/adminUser',
    name: 'adminUerM',
    meta: {
      title: '权限管理',
      icon: 'ios-lock',
      access: ['adminUerM']
    },
    component: Main,
    children: [
      {
        path: '/admin/admin/userlist',
        name: 'adminUser',
        meta: {
          title: '平台用户',
          access: ['adminUser']
        },
        component: () => import('@/view/admin/userlist')
      },
      {
        path: '/admin/admin/group',
        name: 'adminGroup',
        meta: {
          title: '平台角色',
          access: ['adminGroup']
        },
        component: () => import('@/view/admin/roleList')
      }
    ]
  },
  {
    path: '/admin/agent',
    name: 'agentM',
    meta: {
      title: '代理管理',
      icon: 'ios-lock',
      // access: ['adminUerM']
    },
    component: Main,
    children: [
      {
        path: '/admin/agent/userlist',
        name: 'agentUser',
        meta: {
          title: '代理列表',
          // access: ['adminUser']
        },
        component: () => import('@/view/agent/user/index')
      },
      {
        path: '/admin/agent/areaList/:id?',
        name: 'agentList',
        meta: {
          title: '代理地区列表',
          hideInMenu: true,
          // access: ['adminUser']
        },
        component: () => import('@/view/agent/user/list')
      },
      {
        path: '/admin/agent/orderlist',
        name: 'agentOrder',
        meta: {
          title: '订单列表',
          // access: ['adminUser']
        },
        component: () => import('@/view/agent/order/index')
      },
    ]
  },
  {
    path: '/admin/book',
    name: 'book',
    meta: {
      title: '绘本管理',
      icon: 'ios-lock',
      // access: ['adminUerM']
    },
    component: Main,
    children: [
      {
        path: '/admin/book/list',
        name: 'bookList',
        meta: {
          title: '阅读列表',
          // access: ['bookList']
        },
        component: () => import('@/view/book/index')
      },
      {
        path: '/admin/book/info/add/:id?',
        name: 'book-info-add',
        meta: {
          title: '添加绘本',
          hideInMenu: true,
          notCache: true,
          // access: ['book-info-add']
        },
        component: () => import('@/view/book/edit')
      },
      {
        path: '/admin/book/detail/list/:pid?',
        name: 'book-detail-list',
        meta: {
          title: '阅读图列表',
          hideInMenu: true,
          notCache: true,
          // access: ['homestay-detail-list']
        },
        component: () => import('@/view/book/detail')
      },
      {
        path: '/admin/book/detail/add2/:pid/:id?',
        name: 'book-detail-add',
        meta: {
          title: '添加阅读图',
          hideInMenu: true,
          notCache: true,
          // access: ['book-detail-add']
        },
        component: () => import('@/view/book/detailAdd')
      },
      {
        path: '/admin/book/detail/add/:pid/:id?',
        name: 'book-detail-add',
        meta: {
          title: '编辑阅读图',
          hideInMenu: true,
          notCache: true,
          // access: ['book-detail-add']
        },
        component: () => import('@/view/book/detailEdit')
      },
      {
        path: '/admin/book/cateList',
        name: 'cateList',
        meta: {
          title: '阅读分类列表',
          // access: ['cateList']
        },
        component: () => import('@/view/book/category/index')
      },
      {
        path: '/admin/bookVideo/cateList',
        name: 'bookCateList',
        meta: {
          title: '导读分类列表',
          // access: ['bookCateList']
        },
        component: () => import('@/view/bookVideo/category/index')
      },
      {
        path: '/admin/bookVideo/list',
        name: 'bookVideoList',
        meta: {
          title: '导读列表',
          // access: ['bookVideoList']
        },
        component: () => import('@/view/bookVideo/index')
      },
      {
        path: '/admin/bookVideo/info/add/:id?',
        name: 'bookVideoAdd',
        meta: {
          title: '添加绘本',
          hideInMenu: true,
          notCache: true,
          // access: ['bookVideoAdd']
        },
        component: () => import('@/view/bookVideo/edit')
      },
      // {
      //   path: '/admin/bookbag/list',
      //   name: 'bookbagList',
      //   meta: {
      //     title: '书袋列表',
      //     // access: ['bookCateList']
      //   },
      //   component: () => import('@/view/bookbag/index')
      // },
    ]
  },
  {
    path: '/admin/systemSetting',
    name: 'systemSetting',
    meta: {
      title: '系统设置',
      icon: 'ios-hammer',
      // access: ['system']
    },
    component: Main,
    children: [
      {
        path: '/admin/system/setting',
        name: 'sysSetting',
        meta: {
          title: '基本配置',
          // access: ['system-setting']
        },
        component: () => import('@/view/system/setting')
      },
      {
        path: '/user/userLevel',
        name: 'userLevel',
        meta: {
          title: '会员等级',
          // access: ['user-userLevel']
        },
        component: () => import('@/view/system/userLevellist.vue')
      },
    ]
  },



]
